import { render, staticRenderFns } from "./HKLDeleteIcon.vue?vue&type=template&id=23aa4df2&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23aa4df2')) {
      api.createRecord('23aa4df2', component.options)
    } else {
      api.reload('23aa4df2', component.options)
    }
    module.hot.accept("./HKLDeleteIcon.vue?vue&type=template&id=23aa4df2&", function () {
      api.rerender('23aa4df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Icon/HKLDeleteIcon.vue"
export default component.exports